import type { Biometry } from 'src/types/biometry/BiometryNativeResponseModel';
import { writable } from 'svelte/store';

const create_biometry_store = () => {
	const { subscribe, set } = writable<Biometry | undefined>();

	return {
		subscribe,
		set,
		reset: () => set(undefined),
	};
};

export const biometry_store = create_biometry_store();

export const biometry_info_store = writable<Biometry | undefined>();
